import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lkwtufmxdmfcqhesovvn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxrd3R1Zm14ZG1mY3FoZXNvdnZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNDg1MTksImV4cCI6MjA2MzkyNDUxOX0.YZc3KLv9xWd2bfV40wXv4wizn8V5sRiPWuBDJJWoQ00";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);